import global from './global.js';
import paginator from './paginator';
import inputNumber from './inputNumber';
import toast from './toast';
import menu from './menu';
import password from './password';
import inputText from './inputText';
import checkbox from './checkbox';
import divider from './divider';
import button from './button';
import toggleSwitch from './toggleSwitch';
import radioButton from './radioButton';
import inputGroup from './inputGroup';
import inputGroupAddon from './inputGroupAddon';
import select from './select';
import selectbutton from './selectbutton';
import togglebutton from './togglebutton';
import avatar from './avatar';
import avatarGroup from './avatargroup';
import inputotp from './inputotp';
import progressbar from './progressbar';
import chip from './chip';
import textarea from './textarea';
import multiselect from './multiselect';
import datepicker from './datepicker/index';
import rating from './rating/index.js';

export default {
    global,
    paginator,
    toast,
    menu,
    inputNumber,
    password,
    inputText,
    checkbox,
    divider,
    toggleSwitch,
    radioButton,
    inputGroup,
    inputGroupAddon,
    select,
    button,
    selectbutton,
    togglebutton,
    avatar,
    avatarGroup,
    inputotp,
    progressbar,
    multiselect,
    chip,
    textarea,
    datepicker,
    rating,
};
